import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, normalizeStyle as _normalizeStyle, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-4ff9ced8"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "panel" }
const _hoisted_2 = ["src"]

import { computed } from 'vue'

type ImagePanelUIProps = {
  url: string
  tb: string
  lr: string
}

export default /*#__PURE__*/_defineComponent({
  props: {
    url: null,
    tb: null,
    lr: null
  },
  setup(__props: any) {

const props = __props as {
  url: string
  tb: string
  lr: string
}



const imgStyle = computed(() => {
  const style = {} as { [key: string]: string }

  if (props.tb === 'top') {
    style.top = '0'
  }

  if (props.tb === 'bottom') {
    style.bottom = '0'
  }

  if (props.lr === 'right') {
    style.right = '0'
  }

  if (props.lr === 'left') {
    style.left = '0'
  }

  return style
})

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("img", {
      src: __props.url,
      style: _normalizeStyle(_unref(imgStyle)),
      alt: ""
    }, null, 12, _hoisted_2)
  ]))
}
}

})